import request from 'api/request';

export default function moveQuestionUpRoute({ courseId, field, index }) {
  return request({
    url: `/courses/${courseId}/${field}/${index}/up`,
    method: 'PUT',
  });
}
